





































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import Article, { STATUS, STATUS_ARRAY_INPUT, SETTING } from "@/model/article";
import Image from "@/model/image";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import Multiselect from "vue-multiselect";
import QCalendar from "@/common/qCalendar.vue";
import moment from "moment";
import uploadImage from "@/components/common/uploadImage.vue";
import { compareWithKeys, formatImageUrl } from "@/common/utils";
import { PostGroupMangerService as postGroupApi } from "@/common/api/services/PostGroupMangerService";
import { BlogManagerTagService as tagApi } from "@/common/api/services/BlogManagerTagService";
import { BlogManagerArticleService } from "@/common/api/services/BlogManagerArticleService";
import { namespace } from "vuex-class";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.use(VueQuillEditor);

const auth = namespace("Auth");

@Component({
  name: "BlogEdit",
  components: {
    Multiselect,
    QCalendar,
    QErrors,
    uploadImage,
    vSelect,
  },
})
export default class BlogEdit extends Vue {
  @auth.Getter
  getUsingGroup!: number;
  @auth.Getter
  getUsingGroupName!: string;
  @auth.Getter
  isPrivateUsingGroup: boolean;
  public dateConfig = {
    minDate: new Date(),
    dateFormat: "Y-m-d H:i",
    enableTime: true,
    minuteIncrement: 15,
    defaultHour: 0,
    defaultMinute: 0,
    allowInput: false,
  };

  editorConfig = {
    placeholder: "",
    modules: {
      toolbar: [
        [{ header: [2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        ["link"],
      ],
    },
  };

  public uploadOptions = {
    maxFilesize: 5, // 5mb
    acceptedFiles: ".jpg,.png,.jpeg",
  };

  public groupImage: Image = new Image();
  public imageUrl = "";

  public article: Article = new Article();
  public initData;
  public id: number = null;
  public title = "";
  public errors: any = {};
  public errorStyle = {
    maxWidth: "100%",
  };
  public selectedGroups = [];
  public selectedTags = [];
  public postGroups = [];
  public files = [];
  public tags = [];
  public recentTags = [];
  public defaultAllGroup = { id: "all", name: "制限なし" };
  public statusList = STATUS_ARRAY_INPUT;
  public statusOpen = STATUS.OPEN;
  public settingNow = SETTING.NOW;
  public settingDate = SETTING.DATE;
  public uploading = false;
  public previewable = false;
  public blogPreviewData: Article = new Article();
  public newImage = {};
  public includePostGroups: any = [];

  async mounted() {
    this.id = Number.parseInt(this.$route.params.id);
    this.tag();
    this.getRecentTags();
    this.findGroupImage();

    if (this.id) {
      await this.findArticle();
      this.includePostGroups = this.article.post_groups.map(
        (post_group) => post_group.id
      );
      this.selectedGroups = this.article.post_groups;
      this.selectedTags = this.article.tags;
      this.previewable = true;
    } else {
      this.article.post_groups = this.selectedGroups = [this.defaultAllGroup];
    }
    this.setTitle();
    this.postGroup();
    this.initData = { ...this.article };

    window.onpopstate = (event) => {
      return this.$router.push({ name: "admin.blog" });
    };
  }

  public async postGroup() {
    let result = await postGroupApi.postGroup({
      groupId: this.getUsingGroup,
      includes: this.includePostGroups,
    });
    this.postGroups = result.data.post_groups;
    if (this.postGroups.length > 0) {
      this.postGroups.unshift(this.defaultAllGroup);
    }
  }

  public async tag() {
    let result = await tagApi.groupAdminTag({
      count: null,
      keyword: null,
    });
    this.tags = result.data.tags;
  }

  public async findArticle() {
    const result = await BlogManagerArticleService.groupAdminArticleShow({
      id: this.id,
      groupId: this.getUsingGroup,
    });
    this.article = new Article(result.data.article);
    if (
      this.article.open_satatus === "open" &&
      moment(this.article.post_date).isBefore(moment())
    ) {
      this.article.release_setting = SETTING.NOW;
      this.article.post_date = null;
    }
  }

  public async findGroupImage() {
    const result = await BlogManagerArticleService.groupAdminArticlePreview({
      groupId: this.getUsingGroup,
    });
    this.groupImage = new Image(result.data.image);
    this.imageUrl = this.formatUrl(this.groupImage.name);
  }

  public async findImage(imageId, index) {
    const result = await BlogManagerArticleService.groupAdminArticleImage({
      id: imageId,
    });
    this.newImage = await new Image(result.data.image);
    this.blogPreviewData.images.splice(index, 1, this.newImage);
  }

  formatUrl(fileName) {
    return formatImageUrl(fileName, "1600x960", "contain");
  }

  public setTitle() {
    this.title = this.isCreated
      ? "記事の新規作成"
      : this.article.title + "の編集";
  }

  public backBlog() {
    this.$router.push({ name: "admin.blog" });
  }

  get isCreated() {
    return !this.id;
  }

  public isChanged() {
    return !compareWithKeys(this.article, this.initData, [
      "title",
      "context",
      "open_satatus",
      "post_date",
      "release_setting",
      "post_groups",
      "tags",
    ]);
  }

  public isPostGroupChecked(value: any): boolean {
    return this.selectedGroups.some((group) => value.id == group.id);
  }

  public async changeTags() {
    let found = this.selectedTags.find((item) => item.id === undefined);
    if (found !== undefined) {
      if (typeof found !== "object") {
        found = { name: found };
      }
      let result = await tagApi.groupAdminTagCreate({
        name: found.name,
      });
      this.selectedTags.splice(
        this.selectedTags.length - 1,
        1,
        result.data.tag
      );
    }
    this.article.tags = this.selectedTags;
    this.setRecentTags();
  }

  public getRecentTags() {
    let recent_tags = localStorage.getItem("recent_tags");
    this.recentTags = JSON.parse(recent_tags);
  }

  public setRecentTags() {
    if (this.selectedTags.length === 0) {
      return;
    }
    let storageTags = [];
    if (this.recentTags !== null) {
      storageTags = [...this.recentTags];
    }
    this.selectedTags.find(function (item) {
      let result = storageTags.findIndex((value) => value.id === item.id);
      if (result > -1) {
        storageTags.splice(result, 1);
      }
      storageTags.unshift(item);
    });
    if (storageTags.length > 10) {
      storageTags.splice(10);
    }
    localStorage.setItem("recent_tags", JSON.stringify(storageTags));
  }

  public changeRecentTags(item) {
    this.selectedTags.push(item);
    this.changeTags();
  }

  public changePostGroup() {
    if (this.selectedGroups.length === 0) {
      this.selectedGroups.push(this.defaultAllGroup);
    } else if (
      this.selectedGroups.some((item) => item.id === "all") &&
      this.selectedGroups.length > 1
    ) {
      this.selectedGroups = this.selectedGroups.filter((selectedGroup) => {
        return selectedGroup.id != "all";
      });
    }

    this.article.post_groups = this.selectedGroups;
  }

  public changeReleaseSetting() {
    if (this.article.release_setting === SETTING.NOW) {
      this.article.post_date = null;
    } else if (this.article.release_setting == SETTING.DATE) {
      const date = new Date();
      let minutes = date.getMinutes();
      let hours = date.getHours();
      let defaultMinute = "00";

      if (minutes > 0 && minutes <= 15) {
        defaultMinute = "15";
      } else if (minutes > 15 && minutes <= 30) {
        defaultMinute = "30";
      } else if (minutes > 30 && minutes <= 45) {
        defaultMinute = "45";
      } else if (minutes > 45) {
        hours++;
      }

      this.article.post_date = moment().format(
        "YYYY-MM-DD " + hours + ":" + defaultMinute
      );
    }
  }

  public changeFile(files) {
    this.article.images = files;
  }

  public uploadStatus(flag) {
    this.uploading = flag;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public getSelectedGroup(items): string {
    if (items.length === 0) {
      return "";
    }
    let names: string[] = [];
    for (const item of items) {
      names.push(item.name);
    }
    return names.join();
  }

  public getStatus(item): string {
    let result = this.selectedTags.findIndex((value) => value.id === item.id);
    if (result > -1) {
      return "on";
    }
    return "";
  }

  public getStyle(item): string {
    let result = this.selectedTags.findIndex((value) => value.id === item.id);
    if (result > -1) {
      return "pointer-events: none;";
    }
    return "";
  }

  public async submit() {
    this.errors = {};
    let result;
    let parameterImageIds = [];
    if (this.article.images && this.article.images.length > 0) {
      parameterImageIds = this.article.images.map((item) => {
        return item.id;
      });
    }
    let parameterPostGroupIds = this.article.post_groups.map((item) => {
      return item.id;
    });
    let index = parameterPostGroupIds.indexOf("all");
    if (index > -1) {
      parameterPostGroupIds = parameterPostGroupIds.slice(0, index);
    }
    let parameterTagIds = this.article.tags.map((item) => {
      return item.id;
    });
    let postDate = this.article.post_date;
    if (this.article.release_setting == SETTING.NOW) {
      postDate = moment().format("YYYY-MM-DD HH:mm:ss");
    }
    try {
      if (this.id) {
        result = await BlogManagerArticleService.groupAdminArticleEdit({
          id: this.article.id,
          groupId: this.getUsingGroup,
          title: this.article.title,
          context: this.article.context,
          postDate: postDate,
          openSatatus: this.article.open_satatus,
          releaseSetting: this.article.release_setting,
          imageIds: parameterImageIds,
          tagIds: parameterTagIds,
          postGroupIds: parameterPostGroupIds,
        });
      } else {
        result = await BlogManagerArticleService.groupAdminArticleCreate({
          groupId: this.getUsingGroup,
          title: this.article.title,
          context: this.article.context,
          postDate: postDate,
          openSatatus: this.article.open_satatus,
          releaseSetting: this.article.release_setting,
          imageIds: parameterImageIds,
          tagIds: parameterTagIds,
          postGroupIds: parameterPostGroupIds,
        });
      }
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      QNotify.success({
        text: this.$t(
          this.isCreated ? "common.message.created" : "common.message.updated"
        ),
      });
      this.$router.push({ name: "admin.blog" });
    } else {
      this.errors = result.body.errors;
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.$router.push({ name: "admin.blog" });
        },
      });
    } else {
      this.$router.push({ name: "admin.blog" });
    }
  }

  public async setPreview() {
    this.newImage = {};
    this.blogPreviewData = this.article;
    for (let index = 0; index < this.blogPreviewData.images.length; index++) {
      if (this.blogPreviewData.images[index].filePath) {
        await this.findImage(this.blogPreviewData.images[index].id, index);
      }
    }

    let parameterPostGroupIds = this.blogPreviewData.post_groups.map((item) => {
      return item.id;
    });
    let index = parameterPostGroupIds.indexOf("all");
    if (index > -1) {
      this.blogPreviewData.post_groups = this.postGroups.filter((item) => {
        return item.id !== "all";
      });
    }
  }

  public localStoragePreview() {
    localStorage.setItem(
      "blog_preview_data",
      JSON.stringify(this.blogPreviewData)
    );
    localStorage.setItem(
      "blog_preview_group_name",
      JSON.stringify(this.getUsingGroupName)
    );
    localStorage.setItem(
      "blog_preview_group_image",
      JSON.stringify(this.groupImage)
    );
    localStorage.setItem(
      "blog_preview_image_url",
      JSON.stringify(this.imageUrl)
    );
  }

  public async preview() {
    await this.setPreview();
    this.localStoragePreview();

    let previewRoute = this.$router.resolve({ name: "admin.blog-preview" });
    window.open(previewRoute.href, "_blank");
  }
}
